<template>
  <developers-search
    :search="route.query.search || ''"
    :how="route.query.how || ''"
    @newSearch="updateGetDevelopers"
  />
  <div v-for="item in developers.developers" :key="item.id">
    <developers-card :developer="item"/>
  </div>
  <pagination
    :number="10"
    :page="Number(route.query.page) || 1"
    :total="developers.total"
    @newPagination="updatePage"
  />
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import {onMounted, ref, computed} from "vue";
import DevelopersSearch from "@/components/pages/developers/DevelopersSearch";
import useDeveloper from "@/hooks/useDeveloper";
import DevelopersCard from "@/components/pages/developers/DevelopersCard";
import Pagination from "@/components/UI/Pagination";
import {useHead} from "@unhead/vue";

export default {
  name: "developers",
  components: {Pagination, DevelopersCard, DevelopersSearch},
  setup() {
    const route = useRoute()
    const router = useRouter()
    const {getDevelopers, developers} = useDeveloper()

    // Метатеги (фиксированные)
    const pageTitle = "Застройщики | P-L-E.ru"
    const pageDescription = "Каталог застройщиков жилых комплексов. Рейтинги, отзывы, завершенные и строящиеся проекты."
    const canonicalUrl = computed(() => {
      const baseUrl = 'https://p-l-e.ru/developers'
      const query = {
        ...(route.query.search && {search: route.query.search}),
        ...(route.query.how && {how: route.query.how}),
        ...(Number(route.query.page) > 1 && {page: route.query.page})
      }
      const queryString = new URLSearchParams(query).toString()
      return queryString ? `${baseUrl}?${queryString}` : baseUrl
    })

    useHead({
      title: pageTitle,
      meta: [
        {name: 'description', content: pageDescription},
        {property: 'og:title', content: pageTitle},
        {property: 'og:description', content: pageDescription},
        {property: 'og:url', content: canonicalUrl},
        {property: 'og:type', content: 'website'},
        {name: 'twitter:card', content: 'summary_large_image'}
      ],
      link: [
        {rel: 'canonical', href: canonicalUrl}
      ]
    })

    const cleanQuery = (newQuery = {}) => {
      const query = {}
      if (newQuery.search || route.query.search) query.search = newQuery.search || route.query.search
      if (newQuery.how || route.query.how) query.how = newQuery.how || route.query.how
      if (newQuery.page || route.query.page) query.page = newQuery.page || route.query.page
      return query
    }

    const updatePage = async (page) => {
      await router.replace({query: cleanQuery({page})})
      await getDevelopers()
    }

    const updateGetDevelopers = async (search, how) => {
      await router.replace({
        query: cleanQuery({search, how, page: 1})
      })
      await getDevelopers()
    }

    onMounted(async () => {
      await getDevelopers()
    })

    return {
      updateGetDevelopers,
      updatePage,
      developers,
      route
    }
  }
}
</script>

<style scoped>
/* Стили остаются без изменений */
</style>